import { Datatable } from '../index';

const BasicComposition = () => {
  return (
    <>
      <Datatable.Filter />
      <Datatable.Header />
      <Datatable.Background>
        <Datatable.Table />
        <hr />
        <Datatable.Footer />
      </Datatable.Background>
    </>
  );
};

export default BasicComposition;
